<template>
    <div v-if="bizAuth.viewReport.hasRight" class="page-setting biz-financial-management-default parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1 v-if="reportGroupName">{{$route.meta.title}}{{' - '+reportGroupName}}</h1>
            <h1 v-else>{{$route.meta.title}}{{isAllGroup || isBizVerified != 'NORMAL'?'':' - '+userGroupName}}</h1>
            <div class="btn-group">
                <rent-select class="select-scroll" v-if="isAllGroup" refName="orgGroup" style="margin-bottom: 16px;" :selectMsg="reportGroupName?reportGroupName:'全部分群'" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefalut">
                    <ul>
                        <li>全部分群</li>
                        <li v-for="(item, index) in groupList" :key="index" :data-id="item.id" :data-name="item.groupName">
                            {{item.groupName}}
                        </li>
                    </ul>
                </rent-select>
            </div>
        </div>
        <report-over-view-total></report-over-view-total>
        <!-- <tabs :key="componentKey">
            <tab name="今日" :selected="selected.today" >
            </tab>
            <tab name="近七天" :selected="selected.week" >
            </tab>
            <tab name="近一個月" :selected="selected.month" >
            </tab>
            <tab name="本季" :selected="selected.season" >
            </tab>
            <tab name="今年" :selected="selected.year" >
            </tab>
        </tabs> -->
        <financial-chart></financial-chart>
    </div>
</template>
<script>
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import reportOverViewTotal from '@/components/bussiness/financialReport/reportOverview/reportOverViewTotal.vue';
import financialChart from '@/components/bussiness/financialReport/reportOverview/financialChart.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import { mapGetters } from 'vuex'

export default {
    name: 'TenantManagement',
    data () {
        return {
            hash: null,
            myHeight: (window.innerHeight) + 'px',
            listIsFixed: false,
            selected: {
                today: true,
                week: false,
                month: false,
                season: false,
                year: false,
            },
            componentKey: 0,
        }
    },
    mounted () {
        this.$analytics.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                this.hash = val.hash
                this.forceUpdate()
                this.$store.dispatch('setGroupName', null)
            },
            immediate: true,
            deep: true
        },
        'bizAuth.viewReport.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        getSelectId: function (value) {
            if( value.ref == 'orgGroup' ){
                this.$store.dispatch('getBizReportOverViewIncomeList', value.id?value.id:null)
                this.$store.dispatch('setGroupName', value.name)
            }
        },
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)

            if( hashTag == '#今日' ){
                this.selected.today = true
                this.$store.dispatch('getBizLedgerMgtList', 'DAY')
            }else if( hashTag == '#近七天' ){
                this.selected.week = true
                this.$store.dispatch('getBizLedgerMgtList', 'WEEK')
            }else if( hashTag == '#近一個月' ){
                this.selected.month = true
                this.$store.dispatch('getBizLedgerMgtList', 'MONTH')
            }else if( hashTag == '#本季' ){
                this.selected.season = true
                this.$store.dispatch('getBizLedgerMgtList', 'SEASON')
            }else if( hashTag == '#今年' ){
                this.selected.year = true
                this.$store.dispatch('getBizLedgerMgtList', 'YEAR')
            }else{
                this.selected.today = true
                this.$store.dispatch('getBizLedgerMgtList', 'DAY')
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.today = false
            this.selected.week = false
            this.selected.month = false
            this.selected.season = false
            this.selected.year = false
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        },
        setFilterQuery: function (value) {
            console.log(value)
            this.$store.dispatch('setIncomeFilterQuery', value)
        },
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            isModalMode: 'GET_MODAL_MODE',
            reportGroupName: 'GET_BIZ_REPORT_OVER_VIEW_GROUP_NAME',
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            groupList: 'GET_ORG_GROUP_LIST',
            userGroupName: 'GET_BIZ_GROUP_NAME',
            isBizVerified: 'GET_BIZ_COMPANY_IS_VERIFIED',
        })
    },
    components: {
        Tabs,
        Tab,
        financialChart,
        reportOverViewTotal,
        RentSelect
    }
}
</script>
<style lang="scss">
    .biz-financial-management-default{
        .page-header{
            .btn-group{
                .biz-rent-select{
                    width: 216px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/financialReport/reportOverview/reportOverviewDefault.vue